import gql from 'graphql-tag';

import integrationItemsPageFragment from '../fragments/integrationItemsPageFragment';

export default gql`
  query integrationItemsPage(
    $integrationID: DokkioID
    $parentRemoteID: ID
    $integrationItemType: IntegrationItemType
    $name: String
    $count: Int
    $offset: Int
  ) {
    integrationItemsPage(
      integrationID: $integrationID
      parentRemoteID: $parentRemoteID
      integrationItemType: $integrationItemType
      name: $name
      count: $count
      offset: $offset
    ) {
      ...integrationItemsPageFragment
    }
  }
  ${integrationItemsPageFragment}
`;
